import { render, staticRenderFns } from "./SurgeryFinalEvaluationPage.vue?vue&type=template&id=006ffb7c&"
import script from "./SurgeryFinalEvaluationPage.vue?vue&type=script&lang=js&"
export * from "./SurgeryFinalEvaluationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports